module.exports = __webpack_public_path__ + "img/badge_gray_spe-transition.55d81904.svg";